<div class="container-fluid pt-3">
    <div class="container-fluid" *ngIf="lot">
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.lotId">
                    Lot ID
                </label>
            </div>
            <div class="col">
                <truncate-span [textInput]="lot.lotId"></truncate-span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.lotUUID">
                    Lot UID
                </label>
            </div>
            <div class="col">
                <truncate-span [textInput]="lot.lotUUID"></truncate-span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.stockId">
                    Stock ID
                </label>
            </div>
            <div class="col">
                <truncate-span [textInput]="lot.stockId"></truncate-span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.gid">
                    GID
                </label>
            </div>
            <div class="col">
                <truncate-span [textInput]="lot.gid"></truncate-span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.mgid">
                    Group ID
                </label>
            </div>
            <div class="col">
                <truncate-span [textInput]="lot.mgid"></truncate-span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.designation">
                    Designation
                </label>
            </div>
            <div class="col" placement="bottom">
                <truncate-span [textInput]="lot.designation" [maxLength]="TOOLTIP_MAX_NAME_DISPLAY_SIZE"></truncate-span>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.status">
                    Status
                </label>
            </div>
            <div class="col">
                {{lot.status}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.unitName">
                    Units
                </label>
            </div>
            <div class="col mt-1">
                {{lot.unitName}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.notes">
                    Notes
                </label>
            </div>
            <div class="col">
                {{lot.notes}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.createdByUsername">
                    Username
                </label>
            </div>
            <div class="col">
                {{lot.createdByUsername}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.createdDate">
                    Creation Date
                </label>
            </div>
            <div class="col">
                {{lot.createdDate}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.actualBalance">
                    Actual Balance
                </label>
            </div>
            <div class="col">
                {{lot.actualBalance}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.availableBalance">
                    Available
                </label>
            </div>
            <div class="col">
                {{lot.availableBalance}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.reservedTotal">
                    Reserved
                </label>
            </div>
            <div class="col">
                {{lot.reservedTotal}}
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.withdrawalTotal">
                    Total Withdrawals
                </label>
            </div>
            <div class="col">
                {{lot.withdrawalTotal}}
            </div>
        </div>

        <div class="row mt-2 mb-3">
            <div class="col-3">
                <label class="fw-bold" jhiTranslate="inventoryManagerApp.lot.pendingDeposits">
                    Pending Deposits
                </label>
            </div>
            <div class="col">
                {{lot.pendingDepositsTotal}}
            </div>
        </div>
    </div>
</div>
